// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateProjectModal__dialog___CODrG {
    width: 56rem;
    padding: 2.4rem;

    .CreateProjectModal__dlgHeader___Rvrr1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .CreateProjectModal__dlgLayout___TU5ps {
        align-items: flex-start;
        width: 100%;
        margin: 3.2rem 0;
    }

    .CreateProjectModal__dlgRow___jVh2G {
        width: 100%;
        margin-bottom: 1.6rem;
    }

    .CreateProjectModal__dlgLongRow___uEMWx {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 1.6rem;
    }

    .CreateProjectModal__dlgLongRowItem___CY7xD {
        width: 25.2rem;
        border: none;
    }

    .CreateProjectModal__dlgControls___OGajw {
        display: flex;
        justify-content: space-between;
    }

    /* stylelint-disable-next-line selector-class-pattern -- класс Consta */
    .CreateProjectModal__removeClearIndicator___KVnom .Select-ClearIndicator {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/CreateProjectModal/CreateProjectModal.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;;IAEf;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;QACvB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;;IAEA,uEAAuE;IACvE;QACI,aAAa;IACjB;AACJ","sourcesContent":[".dialog {\n    width: 56rem;\n    padding: 2.4rem;\n\n    .dlgHeader {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .dlgLayout {\n        align-items: flex-start;\n        width: 100%;\n        margin: 3.2rem 0;\n    }\n\n    .dlgRow {\n        width: 100%;\n        margin-bottom: 1.6rem;\n    }\n\n    .dlgLongRow {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        margin-bottom: 1.6rem;\n    }\n\n    .dlgLongRowItem {\n        width: 25.2rem;\n        border: none;\n    }\n\n    .dlgControls {\n        display: flex;\n        justify-content: space-between;\n    }\n\n    /* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n    .removeClearIndicator :global(.Select-ClearIndicator) {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `CreateProjectModal__dialog___CODrG`,
	"dlgHeader": `CreateProjectModal__dlgHeader___Rvrr1`,
	"dlgLayout": `CreateProjectModal__dlgLayout___TU5ps`,
	"dlgRow": `CreateProjectModal__dlgRow___jVh2G`,
	"dlgLongRow": `CreateProjectModal__dlgLongRow___uEMWx`,
	"dlgLongRowItem": `CreateProjectModal__dlgLongRowItem___CY7xD`,
	"dlgControls": `CreateProjectModal__dlgControls___OGajw`,
	"removeClearIndicator": `CreateProjectModal__removeClearIndicator___KVnom`
};
export default ___CSS_LOADER_EXPORT___;
